import {
    UPDATEGATEWAYACCOUNT_SUCCESS,
    UPDATEGATEWAYACCOUNT_FAILED,
    RESET_UPDATEGATEWAYACCOUNT,
    LOADING_UPDATEGATEWAYACCOUNT,
    NETWORK_ERROR_UPDATEGATEWAYACCOUNT
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_UPDATEGATEWAYACCOUNT:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case UPDATEGATEWAYACCOUNT_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case UPDATEGATEWAYACCOUNT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_UPDATEGATEWAYACCOUNT:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_UPDATEGATEWAYACCOUNT:
            return (state = initialState);
        default:
            return state;
    }
};
